export default "__VITE_ASSET__Bu4Z2KEQ__"